module.exports = __webpack_public_path__ + "static/media/RP_Lodgeatmain.0b671420.jpg";